import React from "react";
import PropTypes from "prop-types";
import styles from "./index.module.scss";

const FourImageCollage = ({ fourImageCollageData = {} }) => {
  const { heading = "", images = [] } = fourImageCollageData;
  return (
    <section className={styles.workshops}>
      <h2 className={styles.heading}>{heading}</h2>
      <div className={styles.grid}>
        {images?.map((img, index) => (
          <div key={index} className={styles.card}>
            <img src={img?.fields?.imageUrl} alt={img?.fields?.alt} />
          </div>
        ))}
      </div>
    </section>
  );
};

FourImageCollage.propTypes = {
  fourImageCollageData: PropTypes.shape({
    heading: PropTypes.string,
    images: PropTypes.arrayOf(
      PropTypes.shape({
        fields: PropTypes.shape({
          imageUrl: PropTypes.string,
          alt: PropTypes.string,
        }),
      })
    ),
  }),
};

export default FourImageCollage;
